const URI: string = "https://app.somos.me/api";
// const TOKEN: string = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYyODI4MDQ5NzlmNDY4YjFiMDhiNGIyMyIsInNjb3BlIjoiU3VwZXJBZG1pbiIsImlhdCI6MTY1MzY3MzgzMH0.n6eEiMeRub5Nmr6AtK4RcQduAvIJcJsr5SwzMBmkIDo';
const TOKEN: string =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYyODNjNDEzNTg2MWUzNWY5YzBhYTVhNSIsInNjb3BlIjoiU3VwZXJBZG1pbiIsImlhdCI6MTY1MzY3NDQ1MH0.J_aP9lYIhtxAE5lRLg6JqOdSkYOpm3tO_rsOs-_9Bps";

export { URI, TOKEN };

export const API_URL = process.env.REACT_APP_API_URL;
